import { specialPromotionConstants } from '../constants'

const initialState = {
  error: false,
  errorString: null,
  pageUrl: null,
  promotionRoutes: null,
  provider: null,
  redemptionId: null,
  terms: null,
  termsId: null,
  isRedeemedSuccess: false,
  isFetchingAllPromotions: false,
}

const specialPromotionReducer = (state = initialState, action) => {
  const { response, body } = action
  let errorMessage
  switch (action.type) {
    case specialPromotionConstants.GET_ALL_PROMOTIONS_REQUEST:
      return {
        ...state,
        isFetchingAllPromotions: true,
      }
    case specialPromotionConstants.GET_PROMOTION_SUCCESS:
      return {
        ...state,
        error: false,
        errorString: null,
        termsId: response.result.termsId,
        provider: response.result.contentProviderName,
        pageUrl: response.result.pageUrl,
      }

    case specialPromotionConstants.REDEEM_PROMOTION_SUCCESS:
      return {
        ...state,
        error: false,
        errorString: null,
        redemptionId: response.redemptionId,
        isRedeemedSuccess: true,
      }

    case specialPromotionConstants.GET_PROMOTION_TERMS_SUCCESS:
      return {
        ...state,
        error: false,
        errorString: null,
        terms: response.terms[0],
      }

    case specialPromotionConstants.GET_ALL_PROMOTIONS_SUCCESS:
      return {
        ...state,
        error: false,
        errorString: null,
        promotionRoutes: response.allPromotions,
        isFetchingAllPromotions: false,
      }

    case specialPromotionConstants.GET_ALL_PROMOTIONS_FAILURE:
      return {
        ...state,
        isFetchingAllPromotions: false,
      }

    case specialPromotionConstants.REDEEM_PROMOTION_ERROR:
      if (action.error.errors && action.error.errors.length) {
        errorMessage = action.error.errors[0].message
      } else if (action.error.errors && action.error.errors.message) {
        errorMessage = action.error.errors.message
      } else {
        errorMessage = '500'
      }
      return {
        ...state,
        error: true,
        errorString: errorMessage,
      }

    default:
      return state
  }
}

export default specialPromotionReducer
